import { Link } from 'react-router-dom';
import { categories } from '@/mocks/news';

export default function ChannelMatrix() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <p className="text-xs text-foreground-500 font-label uppercase tracking-widest mb-3">频道分类</p>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-tight">
            吃瓜频道
            <br />
            随心切换
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="bg-background-200/60 hover:bg-background-200 rounded-lg p-6 transition-colors duration-200 group"
            >
              <div className="w-10 h-10 flex items-center justify-center text-accent-500 mb-5">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}